import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default {
    install(app) {
        app.component('Swiper', Swiper);
        app.component('SwiperSlide', SwiperSlide);
    }
};
